exports.f = Object.getOwnPropertySymbols;


//////////////////
// WEBPACK FOOTER
// ./~/.2.4.1@core-js/library/modules/_object-gops.js
// module id = 111
// module chunks = 2